import { useCompanyApi } from '@lendica/hooks';
import { useMemo } from 'react';
import type { User, UserTypeLabel, Invitation } from '@lendica/utils';
import { UserType } from '@lendica/utils';
export { getCompanyDetails } from '@lendica/api';

export interface MembersResponseItem {
    id: string;
    user: User;
    user_type: UserType;
    user_type_display: UserTypeLabel;
    is_active_in_company: boolean;
    add_time: string;
    update_time: string;
}

export interface PaginatedResponse<T> {
    count: number;
    next: string | null;
    previous: string | null;
    results: T[];
}

export interface SendInvitationsSuccessResponse {
    success: boolean;
    message: string;
    data: {
        successful: string[];
        extended: string[];
        failed: (string | { email: string; reason: string })[];
    };
}

export const useMembershipApi = () => {
    const api = useCompanyApi();
    return useMemo(
        () => ({
            getMembers: (params?: {
                is_active?: boolean;
                search?: string;
                role?: string;
                page?: number;
                page_size?: number;
            }) => api.get<PaginatedResponse<MembersResponseItem>>('/members', { params }),
            getInvitations: (params?: {
                is_active?: boolean;
                search?: string;
                role?: string;
                page?: number;
                page_size?: number;
            }) => api.get<PaginatedResponse<Invitation>>('/invitations', { params }),
            sendInvitations: (emails: string[], role: UserType = UserType.Admin) =>
                api.post<SendInvitationsSuccessResponse>(
                    '/invitations/submit',
                    { emails, role },
                    { unwrap: false }
                ),
            resendInvitationById: (invitation_id: string) =>
                api.post<{ message: string }>(
                    '/invitations/resend',
                    { invitation_id },
                    { unwrap: false }
                ),
            revokeInvitationById: (invitation_id: string) =>
                api.post<{ message?: string; error?: string }>(
                    '/invitations/delete',
                    { invitation_id },
                    { unwrap: false }
                ),
        }),
        [api]
    );
};
